var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSofi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Diplomas--inject-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Diploma--inject-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "29.53 128.71 31.97 130.11 92.82 94.97 90.39 93.57 29.53 128.71",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.39 93.57 31.97 127.3 31.97 76.66 90.39 42.93 90.39 93.57",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.26,37.31l-65.73,38v59.07l65.73-38ZM92.82,95,32,130.11V76.66L92.82,41.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.82 94.97 90.39 93.57 90.39 42.93 92.82 41.53 92.82 94.97",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.26 37.31 92.82 35.91 27.1 73.85 29.53 75.26 95.26 37.31",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.1 73.85 29.53 75.26 29.53 134.33 27.1 132.92 27.1 73.85",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M78.93,85.06C81.2,83.75,83,84.81,83,87.43a9.09,9.09,0,0,1-4.11,7.12c-2.27,1.31-4.11.24-4.11-2.38A9.07,9.07,0,0,1,78.93,85.06Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.73,74.36,76.66,56.48c.86-.5,1.56-.09,1.56.9v.09a3.46,3.46,0,0,1-1.56,2.7L45.73,78.06c-.86.5-1.56.09-1.56-.9v-.1A3.43,3.43,0,0,1,45.73,74.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.83,88.44,81.55,64.93c.86-.5,1.56-.27,1.56.5a3.13,3.13,0,0,1-1.56,2.31L40.8,91.26c-.86.5-1.55.27-1.54-.51A3.15,3.15,0,0,1,40.83,88.44Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.83,94.05,81.55,70.54c.86-.5,1.56-.27,1.56.51a3.11,3.11,0,0,1-1.56,2.3L40.8,96.88c-.86.5-1.55.27-1.54-.52A3.17,3.17,0,0,1,40.83,94.05Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.83,99.67,81.55,76.16c.86-.5,1.56-.27,1.56.5A3.13,3.13,0,0,1,81.55,79L40.8,102.5c-.86.49-1.55.26-1.54-.52A3.15,3.15,0,0,1,40.83,99.67Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.62,97.08a2.38,2.38,0,0,1-1,.27c-.87,0-.79-.89-.76-1.5,0-.28-.37-.7-.57-.34-.53.95-1.2,1.84-1.77,2.76-.34.57-1,1.85-1.84,1.67-.35-.08-.46-.45-.47-.91a4.58,4.58,0,0,0,.55-2.54c0-.27-.48-.59-.62-.23a8.28,8.28,0,0,0-.53,2.33,13.11,13.11,0,0,1-1.31,2c-.29.38-.53.8-.85,1.15-.07.08-.22.3-.34.32-.28,0-.25-.12-.29-.31a2,2,0,0,1,.14-.84h0a.25.25,0,0,1,0-.07h0c0-.28-.35-.69-.49-.35a12.26,12.26,0,0,1-2.39,4l-.16.13c0-.17,0-.33-.06-.49a4.61,4.61,0,0,0-.19-1.11c-.07-.17-.38-.45-.55-.21a18.6,18.6,0,0,1-2.71,3.74,4.08,4.08,0,0,1-.57.4c-.18-.11.11-1.09.14-1.24.11-.45.26-.88.4-1.31a4.5,4.5,0,0,0,.33-1.08c.05-.33-.52-.85-.63-.4,0,.18-.2.63-.37,1.18a29.38,29.38,0,0,1-2.29,3.87A8.92,8.92,0,0,1,49.22,111c-.36.19-1,.47-1.43.19s-.36-.79-.37-1.15a9.27,9.27,0,0,1,.38-2.82,17.65,17.65,0,0,0,3.53-2.49,12.28,12.28,0,0,0,2.66-3c.37-.65.58-1.73-.29-2.1-.61-.26-1.39.17-1.91.45a8.58,8.58,0,0,0-1.94,1.51,11.16,11.16,0,0,0-2.42,4.44c-.08.26-.18.59-.28,1a7.51,7.51,0,0,1-4.48.75c-.09,0-.12.18,0,.2a7.38,7.38,0,0,0,4.39-.42c-.39,1.7-.62,4,1,4.39s3.5-1.55,4.35-2.69a17.91,17.91,0,0,0,1.7-2.74,1.59,1.59,0,0,1,.15-.21c0,.79.16,1.37.93,1.24s1.5-1.25,1.93-1.85.78-1.16,1.15-1.75c.07.71.2,1.52.88,1.38s1.24-1.31,1.56-1.8a14.79,14.79,0,0,0,.77-1.27.87.87,0,0,0,.16.23c.56.61,1.23,0,1.59-.52.52-.68,1.11-1.4,1.59-2.16a1.34,1.34,0,0,0,.68.76c.86.41,1.68-.31,2.18-1A17.3,17.3,0,0,0,69.25,97a1.24,1.24,0,0,0,.6.83,2,2,0,0,0,2.05-.13C72.17,97.52,71.91,96.93,71.62,97.08Zm-19.05,3.4c.4-.21,1.24-.55,1.29.13a2.33,2.33,0,0,1-.55,1.19,14.9,14.9,0,0,1-2.37,2.52,19.41,19.41,0,0,1-3,2.26A9.57,9.57,0,0,1,52.57,100.48Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--diploma--inject-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "110.8 122.55 113.23 123.96 174.08 88.82 171.65 87.42 110.8 122.55",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.65 87.42 113.23 121.15 113.23 70.51 171.65 36.78 171.65 87.42",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.52,31.16l-65.73,38v59.06l65.72-37.94Zm-2.44,57.66L113.23,124V70.51l60.85-35.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.08 88.82 171.65 87.42 171.65 36.78 174.08 35.38 174.08 88.82",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "176.52 31.16 174.09 29.75 108.36 67.7 110.79 69.11 176.52 31.16",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.36 67.7 110.79 69.11 110.8 128.17 108.36 126.77 108.36 67.7",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M160.19,78.9c2.27-1.31,4.11-.24,4.11,2.38a9.07,9.07,0,0,1-4.11,7.11c-2.27,1.31-4.11.25-4.11-2.37A9.09,9.09,0,0,1,160.19,78.9Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127,68.21l30.94-17.88c.86-.5,1.55-.09,1.55.9v.09a3.45,3.45,0,0,1-1.55,2.7L127,71.91c-.86.49-1.56.09-1.56-.9V70.9A3.43,3.43,0,0,1,127,68.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.09,82.28l40.72-23.51c.86-.49,1.56-.27,1.56.51a3.13,3.13,0,0,1-1.56,2.31L122.06,85.11c-.86.5-1.55.27-1.54-.51A3.19,3.19,0,0,1,122.09,82.28Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.09,87.9l40.72-23.51c.86-.5,1.56-.27,1.56.51a3.13,3.13,0,0,1-1.56,2.3L122.06,90.73c-.86.49-1.55.26-1.54-.52A3.17,3.17,0,0,1,122.09,87.9Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.09,93.51,162.81,70c.86-.5,1.56-.27,1.56.5a3.13,3.13,0,0,1-1.56,2.31L122.06,96.34c-.86.5-1.55.27-1.54-.51A3.19,3.19,0,0,1,122.09,93.51Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.88,90.92a2.12,2.12,0,0,1-1,.27c-.87,0-.79-.88-.77-1.49,0-.28-.37-.7-.57-.34-.53,1-1.2,1.83-1.77,2.76-.34.57-1,1.85-1.84,1.67-.35-.08-.46-.45-.46-.92a4.55,4.55,0,0,0,.54-2.54c0-.26-.48-.58-.62-.23a8,8,0,0,0-.52,2.34,14,14,0,0,1-1.32,2c-.28.38-.53.79-.84,1.15-.08.08-.22.3-.34.32-.29,0-.26-.12-.3-.31a2,2,0,0,1,.14-.84h0a.19.19,0,0,1,0-.07h0c0-.27-.35-.68-.49-.34a12.32,12.32,0,0,1-2.39,4l-.16.13c0-.16,0-.32-.06-.48a4.53,4.53,0,0,0-.19-1.11c-.07-.18-.38-.45-.54-.21a19.73,19.73,0,0,1-2.71,3.74,6.32,6.32,0,0,1-.57.4c-.19-.11.1-1.1.14-1.25.11-.44.25-.87.4-1.3a5,5,0,0,0,.32-1.08c.06-.34-.52-.85-.63-.4,0,.18-.2.63-.37,1.18a28.94,28.94,0,0,1-2.29,3.87,8.86,8.86,0,0,1-3.17,3.06c-.37.2-1,.48-1.44.2s-.36-.79-.37-1.16a10,10,0,0,1,.38-2.82,16.88,16.88,0,0,0,3.53-2.49,12.1,12.1,0,0,0,2.67-3c.36-.66.58-1.73-.3-2.1-.61-.26-1.39.16-1.9.45a8.16,8.16,0,0,0-1.94,1.51,11.11,11.11,0,0,0-2.43,4.44c-.08.25-.18.59-.28,1a7.51,7.51,0,0,1-4.48.75c-.08,0-.12.18,0,.19a7.38,7.38,0,0,0,4.39-.41c-.39,1.7-.61,4,1,4.39s3.49-1.55,4.34-2.69a18.36,18.36,0,0,0,1.71-2.75,1.21,1.21,0,0,1,.14-.2c0,.79.16,1.36.93,1.23s1.5-1.24,1.93-1.84.78-1.16,1.16-1.75c.07.71.2,1.52.87,1.38s1.24-1.32,1.56-1.8a11,11,0,0,0,.77-1.27.87.87,0,0,0,.16.23c.56.61,1.23,0,1.6-.52.51-.68,1.1-1.4,1.58-2.16a1.29,1.29,0,0,0,.68.75c.87.41,1.69-.31,2.19-1a18.62,18.62,0,0,0,1.63-2.63,1.27,1.27,0,0,0,.6.83,2,2,0,0,0,2-.13C153.43,91.36,153.17,90.78,152.88,90.92Zm-19,3.41c.4-.21,1.25-.55,1.29.13a2.33,2.33,0,0,1-.55,1.19,15.7,15.7,0,0,1-2.37,2.52,19.33,19.33,0,0,1-3,2.26A9.52,9.52,0,0,1,133.83,94.33Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "331.19 175.65 459.59 249.77 459.58 113.15 331.19 39.05 331.19 175.65",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "462.1 251.23 459.59 252.73 328.67 177.15 331.19 175.65 462.1 251.23",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.92,179.89,464.34,261V110.41L323.92,29.34Zm4.75-142.32,130.91,75.58V252.73L328.67,177.15Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.67 177.15 331.19 175.65 331.19 39.05 328.67 37.57 328.67 177.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.92 29.34 326.48 27.88 466.89 108.95 464.34 110.41 323.92 29.34",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "466.89 108.95 464.34 110.41 464.34 260.96 466.89 259.5 466.89 108.95",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "457.49 140.71 457.49 143.67 328.67 69.2 331.19 67.69 457.49 140.71",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.18 77.71 395.62 76.24 395.62 215.82 398.18 214.36 398.18 77.71",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.87 73.51 395.62 76.24 395.62 215.82 390.87 213.07 390.87 73.51",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.67 69.2 328.67 74.67 459.63 150.57 459.63 145.09 328.67 69.2",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.62 107.99 398.18 106.42 459.59 141.92 459.59 145.09 395.62 107.99",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Boxes--inject-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--boxes--inject-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "291.94 295.99 291.94 254.27 237.75 222.98 237.75 264.7 291.94 295.99",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.94 254.27 366.91 211.05 366.91 252.76 291.94 295.99 291.94 254.27",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.94 254.27 236.14 222.04 312.71 177.88 368.51 210.11 291.94 254.27",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.94 254.27 291.94 264.7 236.14 232.48 236.14 222.04 291.94 254.27",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "368.51 210.11 291.94 254.27 291.94 264.7 368.51 220.55 368.51 210.11",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.75,233.41v2.29L291.94,267V264.7Zm129.16-11.93-75,43.22V267l75-43.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.1,260.61l-18.51-10.69c-.8-.46-1.45-.08-1.45.84V261.7a3.19,3.19,0,0,0,1.45,2.5l18.51,10.69c.8.46,1.44.09,1.44-.83V263.11A3.18,3.18,0,0,0,274.1,260.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.1,260.61l-18.51-10.69c-.8-.46-1.45-.08-1.45.84V261.7a3.19,3.19,0,0,0,1.45,2.5l18.51,10.69c.8.46,1.44.09,1.44-.83V263.11A3.18,3.18,0,0,0,274.1,260.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.91,261.85l-16.14-9.32c-.53-.3-1-.05-1,.56v8.21a2.11,2.11,0,0,0,1,1.66l16.14,9.32c.53.31,1,.06,1-.55v-8.21A2.15,2.15,0,0,0,272.91,261.85Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M272.46,264a.25.25,0,0,0,.21-.12.24.24,0,0,0-.09-.32l-15.24-8.8a.24.24,0,0,0-.32.09.23.23,0,0,0,.08.32l15.24,8.8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M272.46,266a.26.26,0,0,0,.21-.11.24.24,0,0,0-.09-.32l-15.24-8.8a.23.23,0,0,0-.24.4l15.24,8.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M272.46,268.05a.25.25,0,0,0,.21-.12.24.24,0,0,0-.09-.32l-15.24-8.8a.24.24,0,0,0-.32.09.23.23,0,0,0,.08.32l15.24,8.8A.27.27,0,0,0,272.46,268.05Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M272.46,270.06a.26.26,0,0,0,.21-.11.24.24,0,0,0-.09-.32l-15.24-8.8a.23.23,0,0,0-.24.4l15.24,8.8A.27.27,0,0,0,272.46,270.06Z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "364.06 207.54 288.82 250.93 237.47 221.27 312.71 177.88 364.06 207.54",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--box--inject-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "288.36 247.64 288.36 205.92 234.17 174.63 234.17 216.35 288.36 247.64",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.36 205.92 363.33 162.69 363.33 204.41 288.36 247.64 288.36 205.92",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.36 205.92 232.56 173.69 309.13 129.53 364.93 161.76 288.36 205.92",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "288.36 205.92 288.36 216.35 232.56 184.13 232.56 173.69 288.36 205.92",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "364.93 161.76 288.36 205.92 288.36 216.35 364.93 172.2 364.93 161.76",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.17,185.06v2.29l54.19,31.29v-2.29Zm129.16-11.93-75,43.22v2.29l75-43.22Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.52,212.26,252,201.57c-.8-.46-1.45-.09-1.45.84v10.94a3.19,3.19,0,0,0,1.45,2.5l18.51,10.69c.8.46,1.44.09,1.44-.83v-11A3.18,3.18,0,0,0,270.52,212.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.52,212.26,252,201.57c-.8-.46-1.45-.09-1.45.84v10.94a3.19,3.19,0,0,0,1.45,2.5l18.51,10.69c.8.46,1.44.09,1.44-.83v-11A3.18,3.18,0,0,0,270.52,212.26Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.33,213.5l-16.14-9.32c-.53-.3-1-.06-1,.56v8.2a2.11,2.11,0,0,0,1,1.67l16.14,9.32c.54.31,1,.06,1-.56v-8.2A2.11,2.11,0,0,0,269.33,213.5Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M268.88,215.67a.25.25,0,0,0,.21-.12.24.24,0,0,0-.09-.32l-15.24-8.8a.24.24,0,0,0-.23.41l15.24,8.8A.2.2,0,0,0,268.88,215.67Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M268.88,217.68a.26.26,0,0,0,.21-.11.24.24,0,0,0-.09-.32l-15.24-8.8a.23.23,0,1,0-.23.4l15.24,8.8A.2.2,0,0,0,268.88,217.68Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M268.88,219.7a.25.25,0,0,0,.21-.12.24.24,0,0,0-.09-.32l-15.24-8.8a.24.24,0,0,0-.23.41l15.24,8.8A.2.2,0,0,0,268.88,219.7Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M268.88,221.71a.26.26,0,0,0,.21-.11.25.25,0,0,0-.09-.33l-15.24-8.79a.23.23,0,1,0-.23.4l15.24,8.8A.2.2,0,0,0,268.88,221.71Z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.3,350.29c.28-3.67-2.63-7.86-9.11-12.84-11.95-9.18-55.38-39.38-72.25-50.57a.18.18,0,0,0-.14-.15C141.88,277.4,139,213.52,132,183c-.07-.29-.55-2.63-1.53-5.65,0-.14-.1-.27-.14-.41-.14-.41-.29-.82-.44-1.25-.08-.21-.15-.43-.22-.63h0a28.76,28.76,0,0,0-5.56-9.57,13.64,13.64,0,0,0-2.9-2.4c-1.46-1-5-2.77-5.78-3.3-8.79-6.26-31.08,9.62-46.82,16.67-9.79,4.4-18.28,9.87-24.06,20.87h0a66.09,66.09,0,0,0-6.3,20.13c-2.59,15.62-2.07,68-.69,91h0c1.59,38.4,7.25,38.92,15,45.94,13.3,12.09,52.36,36.81,65.4,43.18,23.63,11.55,44.76-1.67,60.23-7.83s44.73-20.5,51.35-24.55c3.93-2.41,6.08-5,6.27-7.87C235.81,356.17,236.2,351.5,236.3,350.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.66,382.66c15.46-6.15,44.74-20.51,51.36-24.56,8.95-5.46,8.67-11.81-2.82-20.64-16-12.27-81.52-56.71-81.52-56.71s-76.21,36.72-94.27,52.76c-2.73,2.43-2.84,7.56-1.89,8.75,9.9,12.37,54,40.92,68.92,48.22C142.08,402,163.21,388.82,178.66,382.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.15,163a2.07,2.07,0,0,0-.25-.15,13.39,13.39,0,0,0-6.53-2c-8-.65-20.6,4.94-39.48,17.14A103.32,103.32,0,0,0,58.7,190.36l-.29.28a39.41,39.41,0,0,0-4.14,4.63c-.21.27-.42.54-.62.83s-.24.31-.34.47c-.26.37-.52.75-.76,1.13-.5.77-1,1.57-1.46,2.39-.06.09-.1.17-.15.26l-.54,1,0,0-5.87-4.06c5.78-11,14.65-16.66,23.79-22.27,15.75-9.65,33.29-22.19,44.46-16.78C113.58,158.64,119.68,162.05,121.15,163Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,183c-1-4-4.55-21.41-17.58-22.11-8-.63-20.6,4.95-39.48,17.15-8.79,5.68-18.92,12.95-24,22.36-7.4,11.69-8.56,44.11-8.12,75.29s2.45,61.13,6.67,66.65c7.42-20.8,95-61.75,105.31-55.56C141.88,277.4,139,213.52,132,183Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.94,275.14c-5.22,20.7-4.78,40.42-2.61,49.28,2.65,10.84,9.23,24.12,29.91,36.29,29.42,17.31,49.87,28.79,49.87,28.79L246.52,326,175.73,284.8Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.94,275.14c-5.22,20.7-4.78,40.42-2.61,49.28,2.65,10.84,9.23,24.12,29.91,36.29,29.42,17.31,49.87,28.79,49.87,28.79L246.52,326,175.73,284.8Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.76,341c-.79-.86-1.55-1.72-2.29-2.57,7.34-1.95,11.66-11.07,10.74-21.36-.52-5.9-1.12-12.59-.32-18.93l-1.28-.16c-.82,6.47-.22,13.24.31,19.21.93,10.38-3.46,18.77-10.4,20.13-14.06-16.84-11.87-33.19-5-54.89l-1.24-.39c-7.5,23.79-8.64,41.25,8.55,59.84,11.3,12.22,42.12,28.9,60.15,40l1.21-.78C144.18,370.07,113.08,353.25,101.76,341Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.4,306.14c-3.92,12.63-12.08,18.65-12.08,18.65,15.26,11.12,27.78,21.43,36.51,29L215.51,347,178,321.79C182.39,312.85,180.4,306.14,180.4,306.14Z",
    style: {
      opacity: 0.35000000000000003
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-35"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "210.9 472.02 46.01 376.82 306.28 226.62 471.17 321.82 210.9 472.02",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.9 472.02 46.01 376.82 306.28 226.62 471.17 321.82 210.9 472.02",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.01 376.82 46.01 388.72 210.9 483.92 210.9 472.02 46.01 376.82",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "46.01 376.82 46.01 388.72 210.9 483.92 210.9 472.02 46.01 376.82",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.9 483.92 471.17 333.72 471.17 321.82 210.9 472.02 210.9 483.92",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.9 472.02 471.17 321.82 471.17 333.72 210.9 483.92 210.9 472.02",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Chest--inject-35",
    d: "M194.89,174.14c-15.71-8.1-34.06-5.65-61.38,4.5-36.38,13.53-41.07,29.7-51.5,57.23-7.3,19.26-14.5,50.49-14.49,65.11,12.75,11.38,28.59,11.75,48.19,9.35,35.67-4.35,63-21.71,64.81-29.71-.3-6.61,6.31-22.25,12.54-37.59,7.23-17.78,9.42-22.38,12.05-35.43C207.43,196.13,207.6,180.68,194.89,174.14Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.21,191c12.77.67,19.81,19,25.87,38.25,6.94,22,21.42,67.19,21.42,67.19l-28.21,18.31S127.52,308.12,119,287c-7.4-18.41-10.67-27.15-15.81-44.41C98.25,225.92,91.31,202.81,114.21,191Z",
    style: {
      fill: "#f1a06a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.88,298l15.9-6.74c-.65-2.6-1.16-6.08-2.11-9.88l-1.29-4c-13.47,7.08-22.49,17.05-23.22,27.55Z",
    style: {
      fill: "#c06d49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,267.26c3.63-1.05,6.77-2.14,10.86-3.51a14,14,0,0,0,3.48-1.61c1.23-.92,1.75-2.92.72-3.46a9.34,9.34,0,0,0-3.35-.42,46.59,46.59,0,0,0-7.46.66c2.32-.71,4.37-1.39,6.39-2.22a2.65,2.65,0,0,0,1.81-3.32c-.26-1.2-1.81-1.71-5.06-1.49-.48-1-2.15-2.27-5.46-1.92-.39-.94-2.31-1.7-4.69-1.48s-3.87.51-6.21.86c-3,.44-4.81,1-7.73,1.68-5.51,1.24-10.8,3.05-16.21,4.65-9.32,2.75-12.63,4-16.94,5.86s-20.68,9.26-33,14.2c-19.91,8-30.1,12.24-35.69,23.55-3.89,7.85-5.25,13.78,2.33,18.48s22.69,2.78,32.64-4c13.78-9.46,28.07-20.79,42.71-30.31,2.61-1.69,4.94-2.81,8.12-2.61a23.63,23.63,0,0,0,7.37-.27,30.15,30.15,0,0,0,5-1.67,47.94,47.94,0,0,0,7.94-5c.95-.7,1.86-1.47,2.84-2.14A33.3,33.3,0,0,1,253,267.26Z",
    style: {
      fill: "#f1a06a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.42,251.89c-1.61.38-3.2.76-4.79,1.17s-3.18.81-4.75,1.26l-4.72,1.4-4.72,1.42a43.48,43.48,0,0,1,4.53-2c1.54-.6,3.11-1.11,4.7-1.57s3.2-.82,4.83-1.1A35.33,35.33,0,0,1,260.42,251.89Z",
    style: {
      fill: "#c06d49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255,250c-1.63.27-3.23.63-4.83,1l-4.79,1.18-4.8,1.18c-1.6.38-3.21.77-4.83,1.1,1.53-.64,3.09-1.17,4.67-1.68s3.17-.95,4.77-1.36,3.22-.75,4.86-1A27.42,27.42,0,0,1,255,250Z",
    style: {
      fill: "#c06d49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.32,280.8a35,35,0,0,0,5.12.09,13.18,13.18,0,0,1-4.09-1.15c-3.56-1.67-4.74-5.82-6.39-3.64s-1.55,4-11.33,11.26c-6.8,5-23.57,18.86-23.64,18.92l4.88-3.56,4.24-3.1,1.71-1.25q2.52-1.85,5.07-3.68h0c1.59-1.15,3.2-2.3,4.81-3.43l1.4-1c1.22-.85,2.43-1.7,3.65-2.53l1.48-1c1.65-1.12,3.31-2.23,5-3.31,2.41-1.56,3.77-2.19,4.9-2.33A10.49,10.49,0,0,1,220.32,280.8Z",
    style: {
      fill: "#c06d49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.67,256.7a2.6,2.6,0,0,0,1.84-3.1,2.56,2.56,0,0,1-1.78,2.11c-1.66.56-6.09,1.5-9.53,2.51a19.41,19.41,0,0,0-5.53,2.62c.83-.2,6.81-1.64,8.61-1.92C259.6,258.21,261.65,257.53,263.67,256.7Z",
    style: {
      fill: "#c06d49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.09,187.86c-14.08,7-24.27,16.37-13.51,53.44s26.79,69.75,30.8,75.34,14.19,6.51,22.39,5.06,16.95-6.18,31.34-17.64c0,0-17.14-16-7.39-31.38L157.79,280s-10.18-32-16-49.78C137.28,216.51,132.16,191.88,114.09,187.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.79,280c-4.78,1.76-15.08,8.16-19.71,16.89,1.86-9.77,9.6-17,18.55-20.51Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.8,271.33l-2.22.94a28.46,28.46,0,0,0-1.25,16.19,30.6,30.6,0,0,0,8,14l2.92-2a5,5,0,0,1-.95,4c-1.5,2.07-5.62,3.47-8.69,6.19s-7.74.33-11.35-4.4c-5.24-6.88-7-21-3-27.82,2.7-4.57,4.6-3.13,8.34-5.26S179.68,268.9,180.8,271.33Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.34,237.82l-22.07,21.1s-8.06-2.28-28.39-15.47c-9.18-5.95-21-13.92-28.47-18.78a107.13,107.13,0,0,0,4.71-17.06c2.31-11.48,2.48-26.93-10.23-33.48a43.4,43.4,0,0,0-17.48-4.73c16.79-.36,29.12,6.35,43.68,19.51C236.32,202.67,279.34,237.82,279.34,237.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.28,169.2s-1-.38-1.5-2.4-.42-3.46-.92-5.71-1.84-6-4-6.17-2.8,4.7-2.5,8.61.46,6.21-1.77,10.86-3.94,10.49-.74,15.18Z",
    style: {
      fill: "#c06d49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.88,160.19c-1.54-3.7-1.87-8.51-2.56-11.51a32.68,32.68,0,0,0-3.48-8.37c-1.56-2.9-2.93-6.76-4.07-7s-2.89,1.09-2.57,3.47c0,0-1.62-1.62-3-3.33s-2.48-3.91-4.27-4.15-2.35,2.56-1.54,4.39,1.38,2.87,1.38,2.87-1.63.93.21,4.19a17.14,17.14,0,0,0,2.78,3.58c.83,2.56,1.07,3.84,2.58,5.86,1,2.39,1.62,4.44,3,6.35-.43,1.86-1.7,4.13-1.36,7.24s.91,3.79-2.37,7.88c-2.21,2.75-6.13,6-8.1,9.73s-3.18,7.5.28,11.69,6.11,7.22,9.41,11.67c2.49,3.36,5.08,7.88,15.64,23.93,8.2,12.47,8.92,14.06,12.75,18.49s6.42,8.27,12.12,10.76A37.28,37.28,0,0,0,273,260.7a12.41,12.41,0,0,0,5-1.17c3.86-2.07,4.9-7.13,4.78-11.51-.17-6.34-2.5-11.89-7.28-17.79-4.39-5.41-7.27-8.16-14.61-14.55-6-5.2-9.51-9-17.77-16.74-7.49-7.07-11.22-11.52-12.71-15.31a26.49,26.49,0,0,1-1.24-12.9C230.22,165.72,231,165.81,228.88,160.19Z",
    style: {
      fill: "#f1a06a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.82,189.57c.8,2.3,2.67,3.91,4.14,5.83s3,3.78,4.46,5.7,2.91,3.84,4.31,5.8,3,4.85,4.36,6.84c-1.54-1.85-3.24-4.67-4.73-6.57s-3-3.81-4.44-5.71l-4.4-5.73-2.2-2.87A8.4,8.4,0,0,1,203.82,189.57Z",
    style: {
      fill: "#c06d49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.2,136.74a18.2,18.2,0,0,0,1.23,3c.48,1,1,1.92,1.56,2.82l.09.14v.21a11.09,11.09,0,0,0,.05,1.72,12.63,12.63,0,0,0,.3,1.72,10.76,10.76,0,0,0,1.38,3.19l.15.25-.08.22a8,8,0,0,0-.36,1.28,12.4,12.4,0,0,0-.21,1.36,10.7,10.7,0,0,0-.06,1.39c0,.47.07.94.12,1.41a8.13,8.13,0,0,1-.75-2.8,9.13,9.13,0,0,1,0-1.48,10,10,0,0,1,.24-1.49l.07.47a9.85,9.85,0,0,1-1.71-3.5,10.39,10.39,0,0,1-.31-1.92,8.09,8.09,0,0,1,.05-2l.07.35a17.46,17.46,0,0,1-1.29-3.11A10.53,10.53,0,0,1,216.2,136.74Z",
    style: {
      fill: "#c06d49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.74,136.52a10.44,10.44,0,0,0,1.33,1.33,12.31,12.31,0,0,0,1.51,1l.1.05.07.18a14.07,14.07,0,0,0,1.86,3.4,10.38,10.38,0,0,0,2.75,2.62l.34.22,0,.39a11.46,11.46,0,0,0,0,2.12,17.93,17.93,0,0,0,.33,2.18,18.21,18.21,0,0,0,.6,2.16c.22.73.53,1.42.82,2.14a14.26,14.26,0,0,1-1.33-1.92,12.52,12.52,0,0,1-1-2.14,11.9,11.9,0,0,1-.57-2.3,8.89,8.89,0,0,1-.08-2.43l.29.61a8.64,8.64,0,0,1-1.72-1.34,10.33,10.33,0,0,1-1.37-1.66,12.78,12.78,0,0,1-1-1.86,11.14,11.14,0,0,1-.65-2l.17.23a8.32,8.32,0,0,1-1.4-1.38A6.93,6.93,0,0,1,208.74,136.52Z",
    style: {
      fill: "#c06d49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.61,160.58a8.8,8.8,0,0,1-.66,4.11,13.21,13.21,0,0,1-2.18,3.57c.23-.66.53-1.29.8-1.92s.55-1.24.79-1.87A31,31,0,0,0,218.61,160.58Z",
    style: {
      fill: "#c06d49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.07,177.37a17,17,0,0,0-.16,7.37,13.41,13.41,0,0,0,1.28,3.41,28.33,28.33,0,0,0,2.07,3.19,10.18,10.18,0,0,1-2.91-2.68,9.7,9.7,0,0,1-1.67-3.65A9.88,9.88,0,0,1,208.07,177.37Z",
    style: {
      fill: "#c06d49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.35,237.2c8,4.38,23.27,6.37,34,1.83,6.38-2.69,6.2-7.53,6.2-7.53s12.61,13.36,5,26c-2.63,4.38-10.25,4-15.2,3.6C254,260.16,244.85,252.54,236.35,237.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.64,231.5l1.52,2.32s13.4,5.56,26,3.11,14.22-8.14,14.22-8.14l-2.27-2.6s2.41-.33,4.5,2.7,2.49,4.66,4.34,6.64,3.33,9.23-3.47,13.53S254,254.68,246.28,251c-6-2.92-6.35-6.79-9.15-9.82S230.29,235.58,232.64,231.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.76,164.67c1.15-8.5-4.25-19.42-5.66-27.58-1.37-7.87-1.8-13.78.58-20,1.41-3.7,5.39-8.07,8.53-8.27,1.14-15,13.7-18.26,19.71-17.85a62.15,62.15,0,0,0,8.41.26c3.44-.32,4.89-2.55,8-3.87,5.34-2.26,12.47-.12,13.48,6.14,3.95-2.75,7.73-1.47,11.78,1a7.87,7.87,0,0,1,3.11,10.29c6.91-1.46,11,4.39,10.47,8-.4,2.68-1.62,4.66-.66,7.47,1.08,3.17,4.65,4.23,6.38,2.49-.53,3.82-2.81,6.14-6.68,4.71a8.6,8.6,0,0,1-1.13,7.24,7.88,7.88,0,0,1-8.42,3.06c-1,1.86-1.69,3.66-3.47,5a13.74,13.74,0,0,1-5.94,2.73c-6.83,1-13.71-.16-20.53-.83l-8.11-.8c-.47,0-2.81-.63-3.21-.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.25,151.18c4.61,5.16,9.59,2.7,9.59,2.7l-8.71,26.47c3.9,9.22,20.05,23.67,30.27,28.22,2.58-6,3.59-14.91,3.42-21.78l1.84-4.19a83.13,83.13,0,0,0,9.73,2.57c6.59,1.1,13-2.54,16.9-8.82,4.12-6.57,8.13-17.83,9.25-26.89a24.83,24.83,0,0,1,1.73-6.75c2.45-5.69,2.46-9.45,2.49-14.86-5.21-7.78-20.71-14.72-38.56-10.28-1.06,9.47-6.74,15.46-14.3,16.83-.45,2.51-2.05,8.7-6,7.34-2.83-1-1.9-4.61-3.84-8.68s-8.53-7.06-12.63-3.23C140.71,135.18,140.19,145.53,145.25,151.18Z",
    style: {
      fill: "#f1a06a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.39,185.17a14.86,14.86,0,0,0,8.54-1.5,18.69,18.69,0,0,0,6.6-5.57,41.9,41.9,0,0,0,4.31-7.62,78.78,78.78,0,0,0,3.15-8.23,75.93,75.93,0,0,0,2.33-8.51c.31-1.43.54-2.88.75-4.33A25.65,25.65,0,0,1,218,145c.42-1.46,1.11-2.81,1.63-4.16a26.42,26.42,0,0,0,1.27-4.2,49.5,49.5,0,0,0,.85-8.79,45,45,0,0,1-.32,8.9,27.09,27.09,0,0,1-1.15,4.33c-.5,1.43-1.12,2.75-1.47,4.16a31,31,0,0,0-.81,4.28c-.19,1.49-.41,3-.72,4.42a75.82,75.82,0,0,1-2.26,8.65,81,81,0,0,1-3.28,8.31,38.32,38.32,0,0,1-4.56,7.72,19.39,19.39,0,0,1-7,5.54A14.65,14.65,0,0,1,191.39,185.17Z",
    style: {
      fill: "#c06d49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.53,158.24l-10.28,1,2.4-20.61C202.05,141.48,204.74,149.54,206.53,158.24Z",
    style: {
      fill: "#c06d49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.07,165c0-.1-.09-.19-.14-.29a5.27,5.27,0,0,0-1.09-1.44,5.5,5.5,0,0,0-1.35-1,7.93,7.93,0,0,0-2.52-.73,4.35,4.35,0,0,0-2.09.18,1,1,0,0,0-.36.2.4.4,0,0,0-.13.38c.05.2.29.28.5.33a19.52,19.52,0,0,1,3.2,1.18,7.23,7.23,0,0,1,2.61,1.78c.36.43.68.88,1,1.32.12.14.3.46.53.4s.22-.44.22-.61A4,4,0,0,0,190.07,165Z",
    style: {
      fill: "#c06d49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.66,182.6c-9.65-4.32-16.93-7.79-19.89-16.69-1.85-5.58-2.33-13.78-2.33-13.78s-1.75,9.2-.35,16.24c1.07,5.43,5.76,11.39,21.06,17.66Z",
    style: {
      fill: "#c06d49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,141.35c.16-1.36,1.45,1,3.35,1.22s3.72-1.72,3.55-.37-1.84,2.27-3.75,2S183.8,142.71,184,141.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.64,145.24c.43-1.3,1.05,1.2,2.67,1.74s3.61-1.07,3.17.22-2.09,1.91-3.7,1.37S206.2,146.54,206.64,145.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.62,132.07l-7,1.79a3.79,3.79,0,0,1,2.69-4.5A3.52,3.52,0,0,1,189.62,132.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,142.19l-5.71-4.52a3.49,3.49,0,0,1,5-.7A3.82,3.82,0,0,1,216,142.19Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Neck--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.4,208.57c-3.62-1.88-12.48-3.68-12.48-3.68-3.31,5.07-4.54,8.75-8.13,13.23-3.58-3.51-18.22-22-19.69-40.43,7.19-5.76,12.86-14.73,15.31-13.38l-1.76,5.35s2.65,12.71,9.13,20.59C167.47,200.82,174.94,201.14,176.4,208.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.4,208.57c3.1-1.79,7.94-7.37,9.18-6.91s4,7.91,4,7.91,1.59-5.78-1.3-14.85-6.66-12.12-6.66-12.12L180.15,186S179.65,198.4,176.4,208.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Coffee--inject-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coffee--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-35",
    d: "M183.67,415.4c9-4.71,23.39-4.82,32.16-.26s8.83,12.06.14,16.76-23.1,4.82-32.17.26S174.67,420.1,183.67,415.4Z",
    style: {
      fill: "#1B4ED8",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--coffee--inject-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--coffee--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185,383.8c8.25-3.14,21.46-3.29,29.5-.32s8.09,7.9.12,11-21.18,3.28-29.49.33S176.73,386.94,185,383.8Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M185,383.8c8.25-3.14,21.46-3.29,29.5-.32s8.09,7.9.12,11-21.18,3.28-29.49.33S176.73,386.94,185,383.8Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M178.27,373.84l42.49-.42-2.67,50.09h0c-.18,1.82-1.86,3.64-5.09,5.07-6.89,3-18.3,3.17-25.49.28-3.37-1.35-5.15-3.13-5.38-4.95h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.76,373.42l-.54,10.17a18.89,18.89,0,0,1-3.53,1.94c-9.14,3.91-24.3,4.07-33.84.37-.41-.16-.76-.33-1.13-.5a21.84,21.84,0,0,1-2.69-1.47l-.76-10.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.6,375.35l-.08-7.66,4.95-.05a23.21,23.21,0,0,1,2.17-1c9.46-3.9,24.61-4.07,33.84-.37a21.56,21.56,0,0,1,2.09,1l4.81-.05.08,7.65h0c0,2.49-2.24,5-6.81,7-9.15,3.91-24.3,4.08-33.84.38C178,380.31,175.63,377.84,175.6,375.35Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M175.6,375.35l-.08-7.66,4.95-.05a23.21,23.21,0,0,1,2.17-1c9.46-3.9,24.61-4.07,33.84-.37a21.56,21.56,0,0,1,2.09,1l4.81-.05.08,7.65h0c0,2.49-2.24,5-6.81,7-9.15,3.91-24.3,4.08-33.84.38C178,380.31,175.63,377.84,175.6,375.35Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M182.57,360.73c9.46-3.91,24.61-4.08,33.84-.38s9.3,9.88.15,13.78-24.29,4.07-33.84.38S173.11,364.64,182.57,360.73Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.9,365.81h0l1.46-6.33,12.16-.14a49.84,49.84,0,0,1,12.08-.13l11.8-.13,1.61,6.29h0c.78,2.28-1,4.7-5.42,6.51-7.54,3.09-20,3.23-27.9.31C181,370.49,179.13,368.11,179.9,365.81Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.9,365.81h0l1.46-6.33,12.16-.14a49.84,49.84,0,0,1,12.08-.13l11.8-.13,1.61,6.29h0c.78,2.28-1,4.7-5.42,6.51-7.54,3.09-20,3.23-27.9.31C181,370.49,179.13,368.11,179.9,365.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.59,355.39c7.17-2.7,18.64-2.82,25.63-.29s7,6.79.1,9.48-18.4,2.82-25.62.28S179.43,358.08,186.59,355.39Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.74,360.16a2.14,2.14,0,0,0,.81.89,11.67,11.67,0,0,0,3,1.46,37.37,37.37,0,0,0,12.07,1.69,35.53,35.53,0,0,0,11.83-1.94,10.24,10.24,0,0,0,2.84-1.54c.58-.48.74-.83.74-.91s-.64-1.28-3.63-2.37a35.61,35.61,0,0,0-11.87-1.67,37.12,37.12,0,0,0-12,2C184.49,358.84,183.75,359.94,183.74,360.16Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M183.74,360.16a2.14,2.14,0,0,0,.81.89,11.67,11.67,0,0,0,3,1.46,37.37,37.37,0,0,0,12.07,1.69,35.53,35.53,0,0,0,11.83-1.94,10.24,10.24,0,0,0,2.84-1.54c.58-.48.74-.83.74-.91s-.64-1.28-3.63-2.37a35.61,35.61,0,0,0-11.87-1.67,37.12,37.12,0,0,0-12,2C184.49,358.84,183.75,359.94,183.74,360.16Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M184.55,361.05a11.67,11.67,0,0,0,3,1.46,37.37,37.37,0,0,0,12.07,1.69,35.53,35.53,0,0,0,11.83-1.94,10.24,10.24,0,0,0,2.84-1.54,10.56,10.56,0,0,0-2.87-1.47,35.61,35.61,0,0,0-11.87-1.67,36.59,36.59,0,0,0-12,1.95A11.2,11.2,0,0,0,184.55,361.05Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M184.55,361.05a11.67,11.67,0,0,0,3,1.46,37.37,37.37,0,0,0,12.07,1.69,35.53,35.53,0,0,0,11.83-1.94,10.24,10.24,0,0,0,2.84-1.54,10.56,10.56,0,0,0-2.87-1.47,35.61,35.61,0,0,0-11.87-1.67,36.59,36.59,0,0,0-12,1.95A11.2,11.2,0,0,0,184.55,361.05Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M191.76,361.14a3.63,3.63,0,0,0-2.85-.52c-.52.31-.09,1,1,1.62a3.57,3.57,0,0,0,2.85.51C193.25,362.44,192.82,361.72,191.76,361.14Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M219.54,407.31c0,1.89-1.84,3.79-5.6,5.27-7.51,3-19.95,3.09-27.79.31-3.91-1.4-5.88-3.25-5.91-5.13l-1.41-18.37c0,2,2.12,4,6.28,5.46,8.31,2.95,21.52,2.81,29.49-.33,4-1.57,6-3.59,6-5.59Z",
    style: {
      fill: "#7be7c6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.35000000000000003
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.54,407.31c0,1.89-1.84,3.79-5.6,5.27-7.51,3-19.95,3.09-27.79.31-3.91-1.4-5.88-3.25-5.91-5.13l-1.41-18.37c0,2,2.12,4,6.28,5.46,8.31,2.95,21.52,2.81,29.49-.33,4-1.57,6-3.59,6-5.59Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.58,408.54a26.55,26.55,0,0,0,1.63-3.13,9.18,9.18,0,0,1,4.75-4.29.62.62,0,0,1,.76.26c1.06,2.12.46,5.1-1.68,7.29s-5.06,2.86-7.2,1.89c-.12-.06-.15-.29-.06-.35A5.92,5.92,0,0,0,206.58,408.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.81,400.55a10.11,10.11,0,0,0-3,1.9,9,9,0,0,0-2.16,3,8.88,8.88,0,0,1-2.72,3.69.59.59,0,0,1-.83-.12c-1.44-2.12-.91-5.4,1.39-7.76s5.24-2.9,7.39-1.78A.58.58,0,0,1,211.81,400.55Z",
    style: {
      fill: "#37474f"
    }
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M283.12,40.72h-5.85V70.84h5.85a2,2,0,0,0,2-2V42.73A2,2,0,0,0,283.12,40.72Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.68,87.54h-.32a1,1,0,0,1-.62-1.77,10.63,10.63,0,0,0,3.84-10.93H224a6,6,0,0,1-6-6V42.73a6,6,0,0,1,6-6h59.15a6,6,0,0,1,6,6V68.82a6,6,0,0,1-6,6h-22C259.76,81.14,253.89,87.54,243.68,87.54ZM224,38.72a4,4,0,0,0-4,4V68.82a4,4,0,0,0,4,4h23.4a1,1,0,0,1,1,.74,12.75,12.75,0,0,1-2.41,11.84C254,84.54,258.5,79,259.3,73.69a1,1,0,0,1,1-.85h22.83a4,4,0,0,0,4-4V42.73a4,4,0,0,0-4-4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.3,
    y: 45.58,
    width: 6.83,
    height: 20.39,
    rx: 1.35,
    style: {
      fill: "#455a64"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSofi);
export default __webpack_public_path__ + "static/media/sofi.01ed6e34c392023d196384a7739dafd3.svg";
export { ForwardRef as ReactComponent };